// Section 17: Priority order. Groups are fed in full in order until stock runs out; the group
// that straddles the boundary gets equal partial shares.
import { applyPins, flattenRanked, priorityFill } from '../../core/allocation';
import { defineRationPolicy } from '../../core/registry';
import type { Config } from '../../config';

export function priority(_config: Config) {
  return defineRationPolicy({
    id: 'priority',
    label: 'Priority only',
    section: 'S17',
    allocate(_ctx, input) {
      const order = flattenRanked(input.ranked);
      const fill = applyPins(order, input.demand, input.available, input.pinned);
      const groups = input.ranked.map((g) => g.filter((id) => input.pinned[id] === undefined));
      for (const id of order) if (input.pinned[id] === undefined) fill.shares[id] = 0;
      priorityFill(groups, input.demand, fill);
      return { shares: fill.shares, order };
    },
  });
}
